import { VirtualCurrency } from 'api/virtual-currency/types'
import { graphql } from 'msw'
import db from '../db'

const virtualCurrencyHandlers = [
  graphql.query('listVirtualCurrencies', (req, res, ctx) => {
    const virtualCurrencies = db.vc.getAll(
      (vc) => vc.application.id === req.variables.id
    )
    return res(ctx.data({ virtualCurrencies }))
  }),

  graphql.mutation('createVirtualCurrency', (req, res, ctx) => {
    const variables = req.variables as VirtualCurrency
    const applicationId = req.variables.applicationId

    const postData = {
      ...variables,
      application: {
        id: applicationId,
      },
    }
    const vc = db.vc.create(postData)

    const application = db.application.get(applicationId)

    db.application.update({
      ...application,
      virtualCurrencies: [...application.virtualCurrencies, vc],
    })

    return res(ctx.data({ vc }))
  }),

  graphql.mutation('updateVirtualCurrency', (req, res, ctx) => {
    const variables = req.variables as VirtualCurrency
    const applicationId = req.variables.applicationId

    const putData = {
      ...variables,
      application: {
        id: applicationId,
      },
    }

    const virtualCurrency = db.vc.update({
      ...putData,
    })

    return res(ctx.data({ virtualCurrencyUpdate: { virtualCurrency } }))
  }),

  graphql.mutation('deleteVirtualCurrency', (req, res, ctx) => {
    const variables = req.variables as VirtualCurrency
    const vc = db.vc.remove(variables.id)

    return res(ctx.data({ vc }))
  }),
]

export default virtualCurrencyHandlers
